import { render } from "./CustomerReview.vue?vue&type=template&id=024d35de&scoped=true"
import script from "./CustomerReview.vue?vue&type=script&lang=js"
export * from "./CustomerReview.vue?vue&type=script&lang=js"

import "./CustomerReview.vue?vue&type=style&index=0&id=024d35de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-024d35de"]])

export default __exports__